import React from 'react';
import omit from 'lodash.omit';
import { myWalletCreditCardSetPrimaryClicked } from '@wix/bi-logger-cashier-ugc/v2';
import { ViewMode } from '@wix/cashier-common/dist/src/types/ViewMode';
import { IRequestStateMeta } from '../../../../reducers/requestsState';
import { InteractionName } from '../../../../types/InteractionName';
import { getBiLogger } from '../../../../utils/biLogger';
import { fedopsLogger } from '../../../../utils/fedopsLogger';
import { IMarkCardPrimaryProps, MarkCardPrimary } from './view';

export interface IMarkCardPrimaryControllerPassedProps extends IMarkCardPrimaryProps {
  cardId: string;
}

export interface IMarkCardPrimaryControllerConnectedProps {
  markCardPrimaryState: IRequestStateMeta;
  desiredPrimaryCardId: string;
  viewMode: ViewMode;
  mobile: boolean;

  markCardPrimary: (cardId: string) => any;
}

export class MarkCardPrimaryController extends React.Component<
  IMarkCardPrimaryControllerPassedProps & IMarkCardPrimaryControllerConnectedProps
> {
  private setAsDefaultRef = React.createRef<any>();

  componentDidUpdate() {
    if (this.props.markCardPrimaryState.error && this.props.cardId === this.props.desiredPrimaryCardId) {
      this.setAsDefaultRef.current.focusElement();
    }
  }

  private handleMarkCardPrimary = () => {
    const {
      cardId,
      markCardPrimaryState,
      viewMode,

      markCardPrimary,
    } = this.props;

    if (viewMode === 'site') {
      const isRetry = markCardPrimaryState.error && markCardPrimaryState.creditCardId === cardId;

      getBiLogger().report(
        myWalletCreditCardSetPrimaryClicked({
          cardId,
          ...(isRetry && {
            isRetry: true,
          }),
        }),
      );

      fedopsLogger.interactionStarted(InteractionName.MARK_CARD_AS_PRIMARY);
      markCardPrimary(cardId);
    }
  };

  render() {
    const passedProps = omit(this.props, ['cardId', 'markCardPrimaryState', 'desiredPrimaryCardId', 'markCardPrimary']);

    const isLoading = this.props.markCardPrimaryState.loading && this.props.cardId === this.props.desiredPrimaryCardId;

    return (
      <MarkCardPrimary
        {...passedProps}
        setAsDefaultRef={this.setAsDefaultRef}
        isLoading={isLoading}
        markCardPrimary={this.handleMarkCardPrimary}
      />
    );
  }
}
